$(window).resize(function () {
    hornstrup.googleMaps.adjustMapHeight();
})
.bind('orientationchange', function () {
    $(window).resize();
});

function mapsInitialize(){
	hornstrup.googleMaps.initAfterScriptLoad();
}





var hornstrup = hornstrup || {};
hornstrup.googleMaps = hornstrup.googleMaps || function () {
	var self = this;
	this.init = function () {
		if($('.focusarea__map').length){
			self.loadScript();
		}
	}

	this.loadScript = function () {
	  var script = document.createElement('script');
	  script.type = 'text/javascript';
	  script.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyDTxNol6MDFhi_jRc87sIIGzrdhKuRiDKo&callback=mapsInitialize'// + '&signed_in=true';
	  document.body.appendChild(script);
	}

	this.initAfterScriptLoad = function () {
		if (typeof (google) != "undefined" && typeof (google.maps) != "undefined") {
			self.buildMap();
		}
	}

	this.adjustMapHeight = function () {
		var addressHolderHeight = $('#container-map .address-holder').outerHeight(true);
		var gMap = $('#google-map');
		var gMapHeight = $(gMap).outerHeight(true);
		if(addressHolderHeight != gMapHeight){
			gMap.height(addressHolderHeight);
		}
	}

	this.buildMap = function () {
		// Check if the google maps is loaded
		if (typeof (google) != "undefined" && typeof (google.maps) != "undefined") {
			// Init variables
			var map_canvas = document.getElementById('google-map');
			var latLng = new google.maps.LatLng(55.7433752,9.5580489);

			// Map options
			var map_options = {
				center: latLng,
				zoom: 13,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				navigationControl: false,
				mapTypeControl: false,
				scaleControl: true,
				draggable: false
			};

			// Init map object
			var map = new google.maps.Map(map_canvas, map_options);

			// Resize event
			google.maps.event.addDomListener(window, 'resize', function () {
				map.setCenter(latLng);
			});

			//make markers
			window['marker1'] = new google.maps.Marker({
				position: latLng
				//icon:'/dist/images/realMarker.png'
			});
			window['marker1'].setMap(map);

		}
	}

	// Make functions public
	return {
		init: init, initAfterScriptLoad:initAfterScriptLoad, adjustMapHeight:adjustMapHeight
	};
}();



